<!-- 所有档案详情 --> 
<template>
  <div>
    <el-dialog
      title="档案详情"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="650px"
      class="dialog-main"
      :close-on-click-modal="false"
      @close="closeDetail"
    >
     <el-tabs v-model="activeName" @tab-click="handleClick">

      <el-tab-pane v-for="(tabItem,tabIndex) in detailData" :key="tabIndex" :label="tabItem.isDefault == 1?'默认档案':'档案'+(tabIndex+1)" :name="tabIndex+''">
        <div class="container">
          <!-- 头部 -->
          <div class="header-wrap">
            <div class="personal-information">
              <div class="avatar-wrap">
                <el-avatar  style="width: 60px; height: 60px;box-shadow: 1px 1px 5px 1px #dfdfdf;" shape="square" :src="detailItem.avatar"></el-avatar>
              </div>
              <div class="name-wrap">
                <div class="ctm-name"  v-if="tabItem.ctmName != null">{{tabItem.ctmName}}
                  <span style="color: #E86452;font-size:13px" > @宏脉</span>
                </div>
                <div style="color: #a09f9fc9; font-size: 13px;">{{detailItem.name}}<span style="color: rgb(70, 189, 10)" v-if="detailItem.type == 1 "> @微信</span><span style="color: rgb(8, 168, 231)" v-else > @{{detailItem.corpName}}</span></div>
              </div>      
            </div>
            <div class="other">
              <div class="other-li">
                <div class="label">{{'绑定时间'}}</div>
                <div class="value">{{tabItem.bindTime}}</div>
              </div>
              <div class="other-li">
                <div class="label">操作员工:</div>
                <div class="value" >{{tabItem.operationName}}</div>
              </div>
            </div>
          </div>
          <!-- main -->
          <div class="main-message">
            <div class="main-message-li" v-for="(item,index) in tabItem.messageContainer" :key="item.id">
              <div class="li-tilte">{{item.title}}</div>
              <div class="li-content">
                <div class="content-row" v-for="(liItem,liIndex) in item.li" :key="liIndex" v-show="(item.id != 3) || (item.id == 3 && liItem.label)">
                  <div class="row-label" >{{liItem.label}}</div>
                  <div>:</div>
                  <div class="row-value">{{liItem.value}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import {allFileDetai} from '@/api/customer/fileOp.js'
export default {
  name: 'AllFileDetail',
  props: ["visiAble","detailItem"],
  data() {
    return {
      dialogVisible: false,
      activeName: '0',
      detailData: [],
      messageContainer: [
        {
          id: 0,
          title: '基础信息',
          li: [
            {
              label: '卡号',
              value: ''
            },
            {
              label: '性别',
              value: ''
            },
            {
              label: '年龄',
              value: ''
            },
            {
              label: '生日',
              value: ''
            },
            {
              label: '职业',
              value: ''
            }
          ]
        },
        {
          id: 1,
          title: '联系方式',
          li: [
            {
              label: '手机号码',
              value: ''
            },
            {
              label: '联系电话',
              value: ''
            },
            {
              label: '微信',
              value: ''
            },
            {
              label: 'Q Q',
              value: ''
            },
            {
              label: '通讯地址',
              value: ''
            }
          ]
        },
        {
          id: 2,
          title: '院务资料',
          li: [
            {
              label: '初诊日期',
              value: ''
            },
            {
              label: '会员类型',
              value: ''
            },
            {
              label: '信息来源',
              value: ''
            },
            {
              label: '渠道名称',
              value: ''
            },
            {
              label: '介绍人',
              value: ''
            },
            {
              label: '开发人员',
              value: ''
            },
            {
              label: '所属顾问',
              value: ''
            },
            {
              label: '客服人员',
              value: ''
            }
          ]
        },
        {
          id: 3,
          title: '其他',
          li: []
        }
      ]
    }
  },
  methods: {
    closeDetail() {
      this.dialogVisible = false;
      this.$emit("closeDetail");
    },
    handleClick(tab, event) {
    },
    // 获取所有档案详情
    getAllFileDetai(params) {
      allFileDetai(params,localStorage.getItem("Authorization"),false).then(res => {
        if(res.error.code == 200) {
          this.detailData = res.data
          this.detailData.forEach(item => {
            let messageContainer = JSON.parse(JSON.stringify(this.messageContainer))
            // 基础信息
            messageContainer[0].li[0].value = item.ctmCode
            messageContainer[0].li[1].value = item.ctmSex == 'W'?'女':'男'
            messageContainer[0].li[2].value = item.ctmAge
            messageContainer[0].li[3].value = item.ctmBirthday
            messageContainer[0].li[4].value = item.wktypeName
            // 联系方式
            messageContainer[1].li[0].value = item.ctmMobile
            messageContainer[1].li[1].value = item.ctmTel
            messageContainer[1].li[2].value = item.ctmWxid
            messageContainer[1].li[3].value = item.ctmJzaddr
            messageContainer[1].li[4].value = item.ctmAddr
            // 院务资料
            // 初诊日期
            messageContainer[2].li[0].value = item.ctmTime
            // 会员类型
            messageContainer[2].li[1].value = item.mtyName
            // 信息来源
            messageContainer[2].li[2].value = item.ctmSourcetype
            // 渠道名称
            messageContainer[2].li[3].value = item.ctmCompany
            // 介绍人
            messageContainer[2].li[4].value = item.ctmGivtype
            // 开发人员
            messageContainer[2].li[5].value = item.ctmEmpcode2Name
            // 所属顾问
            messageContainer[2].li[6].value = item.ctmEmpcode1Name
            // 客服人员
            messageContainer[2].li[7].value = item.ctmEmpcode3Name
            // 其他
            if(item.customLab1) {
              let obj = {
                label: item.customLab1,
                value: item.customName1
              } 
              messageContainer[3].li.push(obj)
            }
            if(item.customLab2) {
              let obj = {
                label: item.customLab2,
                value: item.customName2
              } 
              messageContainer[3].li.push(obj)
            }
            if(item.customLab3) {
              let obj = {
                label: item.customLab3,
                value: item.customName3
              } 
              messageContainer[3].li.push(obj)
            }
            if(item.customLab4) {
              let obj = {
                label: item.customLab4,
                value: item.customName4
              } 
              messageContainer[3].li.push(obj)
            }
            if(item.customLab5) {
              let obj = {
                label: item.customLab5,
                value: item.customName5
              } 
              messageContainer[3].li.push(obj)
            }
            item.messageContainer = JSON.parse(JSON.stringify(messageContainer))
          })
          console.log('detailData',JSON.parse(JSON.stringify(this.detailData)))
          this.dialogVisible = true
        }else {
          this.dialogVisible = false
          this.$emit("closeDetail");
          this.$message.error("获取档案详情失败,请重试！");
        }
      }).catch(action => {
        this.$emit("closeDetail");
        console.log('action',action)
        this.dialogVisible = false
        this.$message.error("获取档案详情失败,请重试！");
      })
    },
  },
  watch: {
    visiAble(newVal) {
      // this.dialogVisible = newVal
    },
    detailItem: {
      handler(newVal,oldVal) {
        // 档案操作日志详情
        this.activeName = '0'
        this.getAllFileDetai(newVal.externalUserId)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.dialog-main {
  .el-dialog__header {
    padding: 20px 30px 10px;
  }
  .el-dialog__body {
    padding: 0px 30px 30px;
  }
}
.container {
  .header-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .personal-information {
      display: flex;
      width: 50%;
      .avatar-wrap {
        margin-right: 10px;
        
      }
      .name-wrap {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .ctm-name {
          color: black;
          font-size: 16px;
        }
      }
    }
    .other {
      width: 50%;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .other-li {
        display: flex;
        align-items: center;
        .label {
          font-size: 14px;
          color: #AAAAAA;
          margin-right: 10px;
        }
      }
    }
  }
  .main-message {
    display: flex;
    flex-wrap: wrap;
    .main-message-li {
      width: 50%;
      margin: 10px 0 0;
      .li-tilte {
        font-size: 15px;
        color: black;
        font-weight: 600;
        line-height: 30px;
      }
      .content-row {
        line-height: 35px;
        display: flex;
        flex-wrap:nowrap;
        .row-label {
          color: #AAAAAA;
          min-width: 4em;
          text-align-last: justify;
          text-align:justify;
        }
        .row-value {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>